import React, { useState } from 'react';
 
const ScrollButton = () => {

    const [visible, setVisible] = useState(false)

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300) {
            setVisible(true)
        }
        else if (scrolled <= 300) {
            setVisible(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' 
        });
    };

    window.addEventListener('scroll', toggleVisible);

    return (
        <div className='my-3'>
            <i onClick={scrollToTop}
                style={{ display: visible ? 'inline' : 'none' }} className="mdi mdi-arrow-up font-weight-bold text-white tx-20 scrollTop" ></i>
        </div>
    );
}

export default ScrollButton;